import { ClerkProvider } from "@clerk/clerk-react";
import { AccountSync } from "./components/AccountSync";
import {
  BrowserRouter,
  MemoryRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import { Layout } from "./components/Layout";
import { LibraryProvider } from "./contexts/LibraryContext";
import { PlayerProvider } from "./contexts/PlayerContext";
import { CurationPage } from "./pages/CurationPage";
import { HomePage } from "./pages/HomePage";
import { LibraryPage } from "./pages/LibraryPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PersonPage } from "./pages/PersonPage";
import { SearchPage } from "./pages/SearchPage";
import { SeriesPage } from "./pages/SeriesPage";
import { WorkPage } from "./pages/WorkPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function ApplicationRoutes() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="saved" element={<LibraryPage />} />
          <Route path="library" element={<Navigate to="/saved" replace />} />
          <Route path="works/:slug" element={<WorkPage />} />
          <Route path="series/:slug" element={<SeriesPage />} />
          <Route path="people/:slug" element={<PersonPage />} />
          <Route path="curations/:slug" element={<CurationPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>
  );
}

function Providers({ children }: React.PropsWithChildren) {
  return (
    <LibraryProvider>
      <AccountSync />
      <PlayerProvider>{children}</PlayerProvider>
    </LibraryProvider>
  );
}

export function App() {
  const app = (
    <Providers>
      <BrowserRouter>
        <ApplicationRoutes />
      </BrowserRouter>
    </Providers>
  );
  return import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ? (
    <ClerkProvider publishableKey={import.meta.env.VITE_CLERK_PUBLISHABLE_KEY}>
      {app}
    </ClerkProvider>
  ) : (
    app
  );
}

export function ServerHomeApp() {
  const app = (
    <Providers>
      <MemoryRouter initialEntries={["/"]}>
        <ApplicationRoutes />
      </MemoryRouter>
    </Providers>
  );
  return import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ? (
    <ClerkProvider publishableKey={import.meta.env.VITE_CLERK_PUBLISHABLE_KEY}>
      {app}
    </ClerkProvider>
  ) : (
    app
  );
}
